import { Dimensions, PixelRatio } from "~/ui/primitives"
const { width, height } = Dimensions.get("window")
export const screen = {
  width: width,
  height: height,
  vw: width / 375,
  vh: height / 667,
  onePixel: 1 / PixelRatio.get(),
}
